<script>
export default {
  name: 'En',
  created () {  
    this.changeLangage('en');
    this.lang =window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'';
  },
  methods: {
    changeLangage(lang) {
        this.$i18n.locale=lang   //设置中英文模式
        localStorage.setItem('language',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
        window.sessionStorage.setItem("language", lang);
        //location.reload();
        window.location = "/";
    }
  }
};
</script>